"use client";
import React from "react";
import { Studio, BookingType } from "./types";
import { StudioCard } from "./StudioCard";
import { BookingTypeSelector } from "./BookingTypeSelector";
import { TimeSlotGrid } from "./TimeSlotGrid";
import { QuantitySelector } from "./QuantitySelector";
import { NavigationButtons } from "./NavigationButtons";


interface StudioSelectionStepProps {
  studios: Studio[];
  selectedStudio: Studio;
  bookingType: BookingType;
  duration: number;
  maxDuration: number;
  visitors: number;
  dates: Date[];
  timeSlots: number[];
  selectedTimeSlots: string[];
  selectedDate: string | null;
  selectedTime: number | null;
  occupiedSlots: Record<string, number[]>;
  sunnySlots: Record<string, number[]>;
  onStudioSelect: (studio: Studio) => void;
  onBookingTypeChange: (type: BookingType) => void;
  onDurationChange: (duration: number) => void;
  onVisitorsChange: (visitors: number) => void;
  onToggleTimeSlot: (date: string, time: number) => void;
  onNextStep: () => void;
  getTotalAmount: () => number;
  getTotalTip: () => string;
  
}

export const StudioSelectionStep: React.FC<StudioSelectionStepProps> = ({
  studios,
  selectedStudio,
  bookingType,
  duration,
  maxDuration,
  visitors,
  dates,
  timeSlots,
  selectedTimeSlots,
  selectedDate,
  selectedTime,
  occupiedSlots,
  sunnySlots,
  onStudioSelect,
  onBookingTypeChange,
  onDurationChange,
  onVisitorsChange,
  onToggleTimeSlot,
  onNextStep,
  getTotalAmount,
  getTotalTip,
}) => {
  const handlePrevStudio = () => {
    handleSelStudio(-1)
  };
  const handleNextStudio = () => {
    handleSelStudio(1)
  };

  const handlePrevDay = () => {
    const el = document.querySelector('#time-grid');
    if (el)  el.scrollBy({left: -120, behavior: "smooth" }); 
  };
  const handleNextDay = () => {
    const el = document.querySelector('#time-grid');
    if (el)  el.scrollBy({left: 120, behavior: "smooth" });    
  };

  const handleSelStudio = (idx:number) => {
    if (!selectedStudio) return;
    const currentIndex = studios.findIndex((s) => s.id === selectedStudio.id);
    let newIndex = (currentIndex + idx) % studios.length;
    if (newIndex<0){
      newIndex = studios.length-1;
    }
    onStudioSelect(studios[newIndex]);
  };

  const isNextDisabled = !(selectedStudio && selectedDate) ;

  return (
    <>


      <section className="flex w-full">
        <button
          className="cursor-pointer border-[none] z-[1] p-2.5"
          onClick={handlePrevStudio}
        >
          <div className="w-2.5 h-2.5 border-b-2 border-l-2 border-solid rotate-45 border-b-black border-l-black" />
        </button>
        <section className="flex overflow-x-hidden gap-5 px-0 py-2.5 scroll-smooth w-full">

          {studios.map((studio) => (
            <StudioCard
              key={studio.id}
              studio={studio}
              data-studio-id={studio.id}
              isSelected={selectedStudio?.id === studio.id}
              setSelectedStudio={onStudioSelect}
            />
          ))}
        </section>
        <button
          className="cursor-pointer border-[none] z-[1] p-2.5"
          onClick={handleNextStudio}
        >
          <div className="w-2.5 h-2.5 border-t-2 border-r-2 border-solid rotate-45 border-r-black border-t-black" />
        </button>
      </section>

      <section className="flex w-full justify-between" id="time-slots">
        <button
          className="cursor-pointer border-[none] z-[1] p-2.5"
          onClick={handlePrevDay}
        >
          <div className="w-2.5 h-2.5 border-b-2 border-l-2 border-solid rotate-45 border-b-black border-l-black" />
        </button>
        <h2 className="mb-6 mt-8 text-1xl font-light text-center uppercase">
          ВЫБЕРИТЕ ВРЕМЯ
        </h2>
        <button
          className="cursor-pointer border-[none] z-[1] p-2.5"
          onClick={handleNextDay}
        >
          <div className="w-2.5 h-2.5 border-t-2 border-r-2 border-solid rotate-45 border-r-black border-t-black" />
        </button>
      </section>

      <section>
        <TimeSlotGrid
          dates={dates}
          timeSlots={timeSlots}
          selectedTimeSlots={selectedTimeSlots}
          selectedDate={selectedDate}
          selectedTime={selectedTime}
          duration={duration}
          maxDuration={maxDuration}
          occupiedSlots={occupiedSlots}
          sunnySlots={sunnySlots}
          onToggleTimeSlot={onToggleTimeSlot}
        />
      </section>

      <section className="flex gap-2 max-md:flex-col">
        <div className="w-6/12 max-md:ml-0 max-md:w-full">
          <QuantitySelector
            value={duration}
            onChange={onDurationChange}
            min={selectedStudio.mindur}
            max={maxDuration}
            sublabel="ДЛИТЕЛЬНОСТЬ"
            suffix="Ч"
            altSuffix="Ч"
          />
        </div>
        <div className="ml-5 w-6/12 max-md:ml-0 max-md:w-full">
          <QuantitySelector
            value={visitors}
            onChange={onVisitorsChange}
            min={1}
            max={99}
            sublabel="КОЛИЧЕСТВО ГОСТЕЙ"
            suffix=" ГОСТЬ"
            altSuffix=" ГОСТЕЙ"
          />
        </div>
      </section>

      <section className="gap-5">
        <BookingTypeSelector
          selectedType={bookingType}
          onTypeChange={onBookingTypeChange}
        />
      </section>

      <NavigationButtons
        onNext={onNextStep}
        nextDisabled={isNextDisabled}
        showTotal={true}
        floatNext={false}
        totalAmount={getTotalAmount()}
        totalTip={getTotalTip()}
        
      />
    </>
  );
};
